<template>
  <v-dialog v-model="value" :width="width" max-width="450" persistent>
    <v-card>
      <v-card-text class="pa-5 text-center">
        <v-icon color="success" size="60" class="my-3">
          check_circle
        </v-icon>
        <div v-if="title" class="display-1 success--text mb-4">
          {{ title }}
        </div>
        <div v-if="text" class="subtitle-1">
          {{ text }}
        </div>
      </v-card-text>
      <v-card-actions class="pa-5 pt-0 d-flex justify-center">
        <v-btn
          @click="$emit('close')"
          color="#2661FF"
          width="150px"
          class="px-5"
        >
          <span class="white--text">
            {{ buttonText }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseSuccessDialog",
  props: {
    width: {
      type: Number,
      required: false,
      default: 350
    },
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    buttonText: {
      type: String,
      required: true,
      default: "Ok"
    }
  }
};
</script>
